import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { Suggestion } from '../../../../service/script.service';

export interface SuggestionDialogData {
  suggestion?: Suggestion;
  isEdit: boolean;
}

export interface SuggestionDialogResult {
  suggestion: Suggestion;
  delete?: boolean;
}

@Component({
  selector: 'app-suggestion-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './suggestion-dialog.component.html',
  styleUrl: './suggestion-dialog.component.less'
})
export class SuggestionDialogComponent {
  form: FormGroup;
  isEdit: boolean;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SuggestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuggestionDialogData
  ) {
    this.isEdit = data.isEdit;
    this.form = this.fb.group({
      tag: [data.suggestion?.tag || '', [Validators.required, Validators.minLength(1)]],
      description: [data.suggestion?.description || '', [Validators.required, Validators.minLength(1)]],
      examples: [data.suggestion?.examples?.join(', ') || '', [Validators.required, Validators.minLength(1)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTagInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove colon characters
    value = value.replace(/:/g, '');
    
    const upperCaseValue = value.toUpperCase();
    this.form.get('tag')?.setValue(upperCaseValue, { emitEvent: false });
  }

  onDescriptionInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove colon characters
    value = value.replace(/:/g, '');
    
    this.form.get('description')?.setValue(value, { emitEvent: false });
  }

  onExamplesInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove colon characters
    value = value.replace(/:/g, '');
    
    this.form.get('examples')?.setValue(value, { emitEvent: false });
  }

  onSave(): void {
    if (this.form.valid) {
      const examples = this.form.get('examples')?.value
        .split(',')
        .map((example: string) => example.trim())
        .filter((example: string) => example.length > 0);

      const result: SuggestionDialogResult = {
        suggestion: {
          tag: this.form.get('tag')?.value.trim(),
          description: this.form.get('description')?.value.trim(),
          examples: examples
        }
      };
      this.dialogRef.close(result);
    }
  }

  onDelete(): void {
    if (this.data.suggestion) {
      const result: SuggestionDialogResult = {
        suggestion: this.data.suggestion,
        delete: true
      };
      this.dialogRef.close(result);
    }
  }
}
